export default __webpack_public_path__ + "static/media/pic5.44c2a542.jpg";